import React from 'react';
import { Lightbulb, CheckCircle2, ArrowRight } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-8 md:py-12 bg-navy-800 relative overflow-hidden" data-id="element-140">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" data-id="element-141"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" data-id="element-142"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-143">
        <div className="text-center mb-6 md:mb-10" data-id="element-144">
          <h2 className="text-2xl md:text-4xl font-heading font-black text-white mb-2 md:mb-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-145">
            <Lightbulb className="w-8 h-8 md:w-10 md:h-10 text-gold-400" data-id="element-146" />
            El cambio que lo transforma todo
          </h2>
          <p className="text-lg md:text-xl text-slate-300" data-id="element-147">
            Cuando tenés un sistema… Todo cambia. De verdad.
          </p>
        </div>

        <div className="bg-navy-900 rounded-2xl p-4 md:p-8 border border-navy-700 shadow-xl mb-6 md:mb-10" data-id="element-148">
          <h3 className="text-lg md:text-xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-149">
            Pasás de:
          </h3>

          <div className="grid md:grid-cols-[1fr_auto_1fr] gap-3 md:gap-8" data-id="element-150">
            <div className="space-y-2 md:space-y-3" data-id="element-151">
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-152">
                <span className="text-red-500 font-bold" data-id="element-153">❌</span>
                <span className="line-through" data-id="element-154">Hacer todo vos</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-155">
                <span className="text-red-500 font-bold" data-id="element-156">❌</span>
                <span className="line-through" data-id="element-157">Repetir constantemente</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-158">
                <span className="text-red-500 font-bold" data-id="element-159">❌</span>
                <span className="line-through" data-id="element-160">Reaccionar</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-161">
                <span className="text-red-500 font-bold" data-id="element-162">❌</span>
                <span className="line-through" data-id="element-163">Vivir en caos</span>
              </div>
            </div>

            <div className="hidden md:flex flex-col justify-center items-center text-gold-500/30" data-id="element-164">
              <ArrowRight className="w-12 h-12" data-id="element-165" />
            </div>

            <div className="space-y-2 md:space-y-3" data-id="element-166">
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-167">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-168" />
                <span className="font-bold" data-id="element-169">Dirigir con claridad</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-170">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-171" />
                <span className="font-bold" data-id="element-172">Tener procesos definidos</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-173">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-174" />
                <span className="font-bold" data-id="element-175">Anticiparte</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-176">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-177" />
                <span className="font-bold" data-id="element-178">Operar con control</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-navy-900 to-navy-950 rounded-2xl p-5 md:p-8 border border-gold-500/30 text-center shadow-2xl" data-id="element-179">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-2 md:mb-3" data-id="element-180">
            ⚓ Existe un sistema para lograr esto
          </h2>
          <p className="text-base md:text-lg text-slate-300 mb-3 md:mb-4" data-id="element-181">
            Y fue creado específicamente para este problema.
          </p>
          <p className="text-sm md:text-base text-slate-400 mb-1" data-id="element-182">Se llama:</p>
          <h3 className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-yellow-200 mb-5 md:mb-8" data-id="element-183">
            CHARTER COMMAND SYSTEM™
          </h3>

          <div className="text-left max-w-2xl mx-auto" data-id="element-184">
            <h4 className="text-base md:text-lg font-bold text-white mb-3 md:mb-4 flex items-center gap-2" data-id="element-185">
              <span data-id="element-186">🔧</span> ¿Qué es Charter Command System™?
            </h4>
            <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-4" data-id="element-187">
              Es un sistema práctico, directo y aplicable desde el primer día.
            </p>
            <p className="text-sm md:text-base text-slate-300 mb-2 md:mb-3" data-id="element-188">
              Diseñado para que puedas:
            </p>
            <ul className="grid sm:grid-cols-2 gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-189">
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-190">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-191"></div>{' '}
                Estructurar tu operación
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-192">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-193"></div>{' '}
                Organizar tu tripulación
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-194">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-195"></div>{' '}
                Definir tareas claras
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-196">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-197"></div>{' '}
                Delegar sin perder control
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-198">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-199"></div>{' '}
                Eliminar el caos operativo
              </li>
            </ul>

            <div className="bg-navy-800/50 p-3 md:p-4 rounded-xl border-l-4 border-gold-500 mb-4 md:mb-6" data-id="element-200">
              <p className="text-sm md:text-base text-slate-300" data-id="element-201">
                No es teoría.
              </p>
              <p className="text-lg md:text-xl font-bold text-white mt-1 md:mt-2" data-id="element-202">
                👉 Es implementación real.
              </p>
            </div>

            <div className="text-center" data-id="element-203">
              <CTAButton data-id="element-204" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}